import { NodeContext } from "../../poly/NodeContext";
import { NodeParamsConfig } from "../utils/params/ParamsConfig";
import { TypedNode } from "../_Base";
class ParamLessNetworkSopParamsConfig extends NodeParamsConfig {
}
export class BaseNetworkSopNode extends TypedNode {
  static context() {
    return NodeContext.SOP;
  }
  cook() {
    this.cookController.endCook();
  }
}
export class ParamLessBaseNetworkSopNode extends BaseNetworkSopNode {
}
